var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[_c('b-row',{attrs:{"id":"criterionOverview"}},[_c('b-col',{staticClass:"shadow-sm"},[_c('b-card-body',[_c('criterion-overview')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }